/*
  Luffka - colour dot for the small variant pills.

  The Bundle & Save per-item pickers and the sticky add-to-cart bar's picker
  are native <select>s, styled as pills in assets/luffka.css under SMALL
  VARIANT PILLS. This script adds one thing: a dot showing the chosen colour.
  It reads each colour from the product's own swatches
  (.color-swatch__custom-color carries --bg-color, next to the radio whose
  value is the colour name), so nothing is configured per product.

  On the .select wrapper it sets the class .lfk-dot and the variable
  --lfk-dot; the CSS draws the dot from those. A value with no matching
  swatch (Hour Format, or a product without colour swatches) gets no dot.

  Safety: if this script never runs, the pills still work and simply show no
  dot. It never changes a select's value.
*/
(() => {
  const SELECTS = '.quantity-break__variant-select, .sticky-atc__variant-select';

  // Swatch colours by value name, e.g. { "Black": "#000000" }.
  const readSwatches = () => {
    const colours = {};
    document.querySelectorAll('.color-swatch').forEach((swatch) => {
      const input = swatch.querySelector('input[type="radio"]');
      const fill = swatch.querySelector('.color-swatch__custom-color');
      if (!input || !fill) return;
      const colour = getComputedStyle(fill).getPropertyValue('--bg-color').trim();
      if (colour) colours[input.value] = colour;
    });
    return colours;
  };

  // The sticky bar's options are variant titles ("Black", or "Black / L" on a
  // product with more options), so each part of the title is tried in turn.
  const colourFor = (value, colours) => {
    if (colours[value]) return colours[value];
    const part = value.split(' / ').find((piece) => colours[piece]);
    return part ? colours[part] : null;
  };

  const paint = () => {
    const colours = readSwatches();
    document.querySelectorAll(SELECTS).forEach((select) => {
      const wrapper = select.closest('.select');
      if (!wrapper) return;
      const colour = colourFor(select.value, colours);
      wrapper.classList.toggle('lfk-dot', Boolean(colour));
      if (colour) wrapper.style.setProperty('--lfk-dot', colour);
      else wrapper.style.removeProperty('--lfk-dot');
    });
  };

  // The theme changes these selects itself (the sticky picker follows the
  // main swatches; bundle cards re-render), not always with a change event on
  // the select, so repaint after any change on the page and after any
  // re-render, once the theme's own handlers have run.
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      paint();
    }, 60);
  };

  document.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  paint();
})();
